<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 35px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de ¿Cómo nos has conocido?</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="rol != 4 && rol != 5"
                    fab
                    :to="{ path: `/guardar-clientes-conocido` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo conocido</span>
        </v-tooltip>
        <v-row>
            <!--<v-col cols="12">
                <v-subheader>Rango de precio</v-subheader>
                <v-range-slider
                    v-model="filtros.precio"
                    :max="max"
                    :min="min"
                    hide-details
                    class="align-center"
                >
                    <template v-slot:prepend>
                        <v-text-field
                            :value="filtros.precio[0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(filtros.precio, 0, $event)"
                        ></v-text-field>
                    </template>
                    <template v-slot:append>
                        <v-text-field
                            :value="filtros.precio[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(filtros.precio, 1, $event)"
                        ></v-text-field>
                    </template>
                </v-range-slider>
            </v-col>
           <v-col cols="12" md="4">
                <v-autocomplete
                    v-model="filtros.id_familia"
                    :items="familias"
                    item-text="nombre"
                    item-value="id"
                    label="Familia"
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
                <v-autocomplete
                    v-model="filtros.id_canal"
                    :items="canales"
                    item-text="nombre"
                    item-value="id"
                    label="Emisora/Canal"
                >
                </v-autocomplete>
            </v-col>
            <v-btn color="success" large @click="getProductos()"
                        >Filtrar</v-btn
                    >-->
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Productos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.precio="{ item }">
                <span>{{ item.precio | format_precio }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    v-if="rol != 4 && rol != 5"
                    :to="{ path: `/guardar-clientes-conocido?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

export default {
    data() {
        return {
            min: 0,

            search: "",
            filtros: {
                id_famlila: null,
                id_canal: null,
                precio: [this.min, 1000000],
            },

            headers: [
                //{ text: "Emisora/canal", value: "canal", sortable: false },
                //{ text: "Familia", value: "familia.nombre", sortable: false },

                { text: "Nombre", value: "nombre", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],

            Productos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    watch: {
        "filtros.id_canal": function () {
            this.getProductos();
        },
        "filtros.id_familia": function () {
            this.getProductos();
        },
        max: function () {
            this.filtros.precio[1] = this.$store.getters.getmaxprecioproducto;
        },
        /*'filtros.precio': debounce(function(val){
               this.getProductos();
        },500)*/
    },
    created() {
        this.getProductosNoFilter();
    },
    methods: {
        getProductosNoFilter() {
            axios.get(`api/get-cliente-conocido`).then(
                (res) => {
                    this.Productos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los clientes conocidos");
                }
            );
        },
        getProductos() {
            let filtros_str = `min=${this.filtros.precio[0]}&max=${this.filtros.precio[1]}`;
            if (this.filtros.id_familia != null)
                filtros_str += `&idFamilia=${this.filtros.id_familia}`;

            if (this.filtros.id_canal != null)
                filtros_str += `&id_canal=${this.filtros.id_canal}`;
            axios.get(`api/get-productos-interes?${filtros_str}`).then(
                (res) => {
                    this.Productos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los clientes conocidos");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Productos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-cliente-conocido", {
                    id: this.Productos[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Cliente conocido eliminado con éxito");
                        this.dialog = false;
                        this.getProductos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el cliente conocido");
                    }
                );
        },
    },
    computed: {
        rol: function () {
            return localStorage.getItem("role");
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
        canales() {
            return this.$store.getters.getcanales;
        },
        familias() {
            return this.$store.getters.getfamilias;
        },
        max() {
            return this.$store.getters.getmaxprecioproducto;
        },
    },
};
</script>
